import { QueryClient } from '@tanstack/react-query';
import { isForbiddenError, shouldRetry } from '@/lib/http-errors';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: shouldRetry,
      // A permission denial is a page-level state, not something every caller
      // re-implements as an inline "failed to load" string — throw it so the
      // router's error boundary renders the access-denied screen. Every other
      // failure stays in `isError` for the caller to render in place.
      throwOnError: isForbiddenError,
    },
  },
});

export { queryClient };
